const Unified = () => (
  <svg
    width="70"
    height="70"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="69.1514"
      height="69.1514"
      rx="1"
      fill="url(#paint0_linear_9113_7276)"
    />
    <path
      d="M25.9322 49.7026H19.4492V43.2197H25.9322V49.7026ZM21.6102 47.5416H23.7712V45.3806H21.6102V47.5416Z"
      fill="#010812"
    />
    <path
      d="M37.8176 49.7026H31.3346V43.2197H37.8176V49.7026ZM33.4956 47.5416H35.6566V45.3806H33.4956V47.5416Z"
      fill="#010812"
    />
    <path
      d="M49.703 49.7026H43.22V43.2197H49.703V49.7026ZM45.381 47.5416H47.542V45.3806H45.381V47.5416Z"
      fill="#010812"
    />
    <path
      d="M34.5761 28.0928C33.7213 28.0928 32.8857 27.8393 32.1749 27.3644C31.4642 26.8895 30.9102 26.2145 30.5831 25.4248C30.256 24.635 30.1704 23.766 30.3372 22.9276C30.5039 22.0893 30.9156 21.3192 31.52 20.7147C32.1244 20.1103 32.8945 19.6987 33.7329 19.5319C34.5713 19.3651 35.4403 19.4507 36.23 19.7778C37.0198 20.105 37.6948 20.6589 38.1697 21.3697C38.6446 22.0804 38.8981 22.916 38.8981 23.7708C38.8968 24.9167 38.441 26.0152 37.6308 26.8255C36.8205 27.6357 35.722 28.0915 34.5761 28.0928ZM34.5761 21.6098C34.1487 21.6098 33.7309 21.7366 33.3755 21.974C33.0201 22.2115 32.7432 22.549 32.5796 22.9438C32.416 23.3387 32.3733 23.7732 32.4566 24.1924C32.54 24.6116 32.7458 24.9966 33.0481 25.2989C33.3503 25.6011 33.7353 25.8069 34.1545 25.8903C34.5737 25.9737 35.0082 25.9309 35.4031 25.7673C35.7979 25.6037 36.1354 25.3268 36.3729 24.9714C36.6103 24.616 36.7371 24.1982 36.7371 23.7708C36.7365 23.1979 36.5086 22.6485 36.1035 22.2434C35.6984 21.8383 35.149 21.6104 34.5761 21.6098Z"
      fill="#010812"
    />
    <path
      d="M45.381 34.5757H39.9786C38.8327 34.5744 37.7341 34.1187 36.9239 33.3084C36.1136 32.4982 35.6579 31.3996 35.6566 30.2538H33.4956C33.4943 31.3996 33.0386 32.4982 32.2283 33.3084C31.4181 34.1187 30.3195 34.5744 29.1736 34.5757H23.7712C23.1983 34.5764 22.649 34.8043 22.2439 35.2094C21.8387 35.6145 21.6109 36.1638 21.6102 36.7367V41.0587H23.7712V36.7367H29.1736C30.7706 36.7362 32.3106 36.1433 33.4956 35.0728V41.0587H35.6566V35.0728C36.8416 36.1433 38.3816 36.7362 39.9786 36.7367H45.381V41.0587H47.542V36.7367C47.5413 36.1638 47.3134 35.6145 46.9083 35.2094C46.5032 34.8043 45.9539 34.5764 45.381 34.5757Z"
      fill="#010812"
    />
    <defs>
      <linearGradient
        id="paint0_linear_9113_7276"
        x1="34.5757"
        y1="0"
        x2="34.5757"
        y2="69.1514"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B8E8FA" />
        <stop offset="1" stopColor="#485CC7" />
      </linearGradient>
    </defs>
  </svg>
);

export default Unified;
